import React from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
interface IControlledSwitchProps {
  isOpen: boolean;
  onClick: () => void;
}

const ToggleSwitch: React.FC<IControlledSwitchProps> = ({
  isOpen = true,
  onClick = () => {},
}) => {
  return (
    <button className="toggle-switch button-container" onClick={onClick}>
      {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
    </button>
  );
};

export default ToggleSwitch;
